import { render, staticRenderFns } from "./reminder-setting.vue?vue&type=template&id=5db018ae"
import script from "./reminder-setting.vue?vue&type=script&lang=js"
export * from "./reminder-setting.vue?vue&type=script&lang=js"
import style0 from "./reminder-setting.vue?vue&type=style&index=0&id=5db018ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports